import React, { useEffect, useState } from 'react';
import { reportProps } from './StopLossAggregateTable';
import {
  CardComponent,
  NoDataTable,
} from '@HomaHealth/ui-component-library/lib/_AIQ-components';
import { Grid } from '@mui/material';
import componentConstants from '../core-utils/messages/componentConstants';
import PptReportTable from '@HomaHealth/ui-component-library/lib/_AIQ-components/atoms/PptReportTable';
import { patientAccessTheme } from '@HomaHealth/ui-component-library/lib/theme/theme';
import { numberToCurrencyFormatter } from '../core-utils/helper-utils/helper';

const TopDrugsTable: React.FC<reportProps> = ({ data }) => {
  const pageConstants = componentConstants.PAGES.UTILIZATION_RX;

  const [topDrugsTableData, setTopDrugsTableData] = useState<any>([]);

  const cellStyles1 = {
    width: '110px',
    color: `${patientAccessTheme.palette.text.highemphasis} !important`,
    paddingLeft: '20px',
    fontSize: '16px',
    fontWeight: 400,
    lineHeight: '24px',
    borderRight: '1px solid white',
    borderBottom: '4px solid white !important',
    backgroundColor: patientAccessTheme.palette.grey[300],
  };

  const headerStyles1 = {
    width: '110px',
    color: `${patientAccessTheme.palette.status.white} !important`,
    paddingLeft: '20px',
    fontSize: '14px',
    fontWeight: 600,
    lineHeight: '24px',
    borderRight: '1px solid white',
    borderBottom: '4px solid white !important',
    backgroundColor: patientAccessTheme.palette.grey[700],
  };

  const topDrugsTableColumn: any[] = [
    {
      name: 'Medication',
      align: 'left',
    },
    {
      name: 'Fills',
      align: 'left',
    },
    {
      name: 'Members',
      align: 'left',
    },
    {
      name: 'Plan Paid Cost',
      align: 'right',
    },
    {
      name: 'Total Cost',
      align: 'right',
    },
  ];

  const formatTopDrugsData = (data: any) => {
    data.sort((a: any, b: any) => b.planPaid - a.planPaid);
    return data.map((item: any) => {
      return [
        item?.medication ? item?.medication : '-',
        item?.claimsCount ? item?.claimsCount : '-',
        item?.claimantsCount ? item?.claimantsCount : '-',
        numberToCurrencyFormatter(item?.planPaid, true, 0),
        numberToCurrencyFormatter(item?.totalCost, true, 0),
      ];
    });
  };

  useEffect(() => {
    setTopDrugsTableData(formatTopDrugsData(data?.topDrugs));
  }, []);
  return (
    <CardComponent
      title={pageConstants.TOP_DRUGS_TABLE.TITLE1}
      width="100%"
      body={
        <>
          <Grid style={{ margin: '7px 0px 0px 6px' }}>
            {topDrugsTableData.length > 0 ? (
              <PptReportTable
                data={topDrugsTableData}
                columns={topDrugsTableColumn}
                cellStyles={cellStyles1}
                headerStyles={headerStyles1}
              />
            ) : (
              <NoDataTable
                height={'100%'}
                width={'100%'}
                content={'No Drugs available'}
              />
            )}
          </Grid>
        </>
      }
    />
  );
};
export default TopDrugsTable;
